import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PharmacyOrdersFilterSettingsModel } from "@/PharmacyOrders/Models/PharmacyOrdersFilterSettingsModel";
import { PharmacyOrdersTableSettingsModel } from "@/PharmacyOrders/Models/PharmacyOrdersTableSettingsModel";
import { PharmacyOrdersStore } from "../PharmacyOrdersStore";

class PharmacyOrderHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.PharmacyOrders.SetPharmacyOrdersIds, this.setPharmacyOrderIds);
        this.RegisterOperation(LocalOperations.PharmacyOrders.SetIFilterSettings, this.setIFilterSettings);
        this.RegisterOperation(LocalOperations.PharmacyOrders.SetTableSettings, this.setTableSettings);
        this.RegisterOperation(LocalOperations.PharmacyOrders.SetCurrentPharmacyOrderId, this.setCurrentPharmacyOrderId);
        this.RegisterOperation(LocalOperations.PharmacyOrders.SetAllergiesAndReactionsTogglerView, this.setAllergiesAndReactionsTogglerView);
    }

    private setPharmacyOrderIds(request: LocalEvent, store: PharmacyOrdersStore): void {
        store.pharmacyOrdersIds = request.Get<string[]>("pharmacyOrdersIds");
        store.totalPharmacyOrders = request.Get<number>("totalCount");
    }

    private setIFilterSettings(request: LocalEvent, store: PharmacyOrdersStore): void {
        store.pharmacyOrdersFilterSettings = request.Get<PharmacyOrdersFilterSettingsModel>("filterSetting");
    }

    private setTableSettings(request: LocalEvent, store: PharmacyOrdersStore): void {
        store.pharmacyOrdersTableSettings = request.Get<PharmacyOrdersTableSettingsModel>("tableSetting");
    }

    private setCurrentPharmacyOrderId(request: LocalEvent, store: PharmacyOrdersStore): void {
        store.currentPharmacyOrderId = request.Get<string>("orderId");
    }

    private setAllergiesAndReactionsTogglerView(request: LocalEvent, store: PharmacyOrdersStore): void {
        store.isAllergiesAndReactionsExpanded = request.Get<boolean>("isAllergiesAndReactionsExpanded");
    }
}

export { PharmacyOrderHandler };
